import React, { Component } from 'react'
import styles from './style.module.less'
import { Head } from '@merchant-backend/common-components'
import Cashier from '@components/Cashier'
import { getMerchantInfo, getJti, logoutAction } from '@util'
import WithStatistic from '@common/WithStatistic'

const HEADER_PARAMS = {
  logo: 'https://qnm.hunliji.com/o_1f1feoar418g2idd1k5i17sii1l9.png',
  merchantInfo: getMerchantInfo() || {},
  ignoreFields: ['shoppingMall'],
  indexPath: `${window.location.hash.split('#')[1]}`,
  logout: logoutAction,
  utils: { getJti },
  renderMenu: () => {},
  renderNavigateBoard: () => {}
}
class CashierOutside extends Component {
  constructor(props) {
    super(props)
    const {
      location: { query }
    } = this.props
    this.state = {
      query
    }
  }
  goBack = () => {
    window.history.back()
  }
  render() {
    return (
      <div className={styles.wrapper}>
        <Head {...HEADER_PARAMS} />
        <>
          <div className={styles.title}>
            收银台
            <div className={styles.goBack} onClick={this.goBack}>
              返回上级
            </div>
          </div>
          <Cashier outsideQuery={this.state.query} />
        </>
      </div>
    )
  }
}
export default WithStatistic(CashierOutside)
